// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__ahShx","modal":"Modal_modal__UGutq"};